// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Td_6","type":"styles_type__2TIKV","choices":"styles_choices__31E9c"};